import { DataLoader } from '@/components/ui/DataLoader';
import { CarryEntityBox } from '@/components/funds-carry/structure/CarryEntityBox';
import { CarryMemberHoldingsBox } from '@/components/funds-carry/structure/CarryMemberHoldingsBox';
import { CarryStructureFundCards } from '@/components/funds-carry/structure/CarryStructureFundCards';
import { signedSummary } from '@/components/funds-carry/structure/carryStructureValues';
import { CarryStructureMap } from '@/components/funds-carry/structure/CarryStructureMap';
import {
  PORTAL_CARRY_COOPERATIVE_PATH,
  PORTAL_CARRY_HOLDING_PATH,
  PORTAL_CARRY_STAK_PATH,
  portalCarryStructureFundPath,
} from '../carryPaths';
import { useCarryStructure } from '../hooks/useCarry';
import type { CarryStructure } from '../services/carryService';

function StructureMap({ structure }: { structure: CarryStructure }) {
  const funds = structure.funds.map((fund) => ({
    ...fund,
    summary: `Your position · ${signedSummary(fund.signed_document_count, fund.document_count)}`,
    to: portalCarryStructureFundPath(fund.fund_id),
  }));

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-semibold">Legal structure</h2>
        <p className="mt-1 text-sm text-muted-foreground">
          Click an entity to see your position in it.
        </p>
      </div>
      <CarryStructureMap
        stak={
          <CarryEntityBox
            entity={structure.stak}
            variant="STAK"
            to={PORTAL_CARRY_STAK_PATH}
          />
        }
        holdings={
          structure.holding && (
            <CarryMemberHoldingsBox
              holdings={[structure.holding]}
              holdingPath={() => PORTAL_CARRY_HOLDING_PATH}
            />
          )
        }
        cooperative={
          <CarryEntityBox
            entity={structure.cooperative}
            variant="COOPERATIVE"
            to={PORTAL_CARRY_COOPERATIVE_PATH}
          />
        }
        funds={<CarryStructureFundCards funds={funds} />}
      />
    </div>
  );
}

export function CarryStructureTab() {
  const query = useCarryStructure();

  return (
    <DataLoader query={query}>
      {(structure: CarryStructure) => <StructureMap structure={structure} />}
    </DataLoader>
  );
}
